<app-base-edit-form-modal
  [fields]="fields"
  [id]="id()"
  [parentId]="userId()"
  [baseService]="userCustomerService"
  (saved)="saved()"
>
</app-base-edit-form-modal>
